import type { Representative } from "../types";
import { catalogService, mapRepresentativeSummaryToRepresentative } from "./catalogService";
import { companiesService } from "./companiesService";
import { eventPackService } from "./eventPackService";

export const representativesService = {
  async getByCompany(eventId: string, companyId: string): Promise<Representative[]> {
    return catalogService.listRepresentatives(eventId, companyId);
  },

  async getById(eventId: string, companyId: string, id: string): Promise<Representative | undefined> {
    const reps = await this.getByCompany(eventId, companyId);
    return reps.find((r) => r.id === id);
  },

  async getByEvent(eventId: string): Promise<Array<Representative & { companyName?: string }>> {
    const fromPack = await eventPackService.listRepresentatives(eventId);
    if (fromPack.length) {
      const companies = await companiesService.list(eventId).catch(() => []);
      const names = new Map(companies.map((c) => [c.id, c.name]));
      return fromPack.map((r) => ({
        ...mapRepresentativeSummaryToRepresentative(r),
        companyName: names.get(r.companyId),
      }));
    }

    const companies = await companiesService.list(eventId);
    const lists = await Promise.all(
      companies.map(async (c) => {
        const reps = await catalogService
          .listRepresentatives(eventId, c.id)
          .catch(() => [] as Representative[]);
        return reps.map((r) => ({ ...r, companyName: c.name }));
      }),
    );
    return lists.flat();
  },

  async search(eventId: string, query: string): Promise<Representative[]> {
    const result = await catalogService.search(eventId, query);
    return result?.representatives ?? [];
  },
};
